import { LocalStorage } from "../constants/local-storage"
import { Path } from "../navigation/constants/routes"
import useStateWithLocalStorage from "../hooks/use-state-with-local-storage.hook"

export const useRedirectUrl = () =>
  useStateWithLocalStorage<Path | string>(LocalStorage.RedirectPath)
